"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionActionType = void 0;
var SubscriptionActionType;
(function (SubscriptionActionType) {
    SubscriptionActionType["Subscribe"] = "subscribe";
    SubscriptionActionType["Dispose"] = "dispose";
    SubscriptionActionType["Update"] = "update";
})(SubscriptionActionType = exports.SubscriptionActionType || (exports.SubscriptionActionType = {}));
